/* Kraba product page behaviour.
   Vanilla, no dependencies, deferred. Everything here only corrects what the
   server already rendered, so the page is complete and correct without it. */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /* A day off is a Sunday, a Saturday when the shop does not work Saturdays,
     or a date listed in the holidays setting as 01.01 or 01.01.2026. */
  function isOff(date, saturday, holidays) {
    var w = date.getDay();
    if (w === 0) return true;
    if (w === 6 && !saturday) return true;
    var dm = '|' + pad(date.getDate()) + '.' + pad(date.getMonth() + 1);
    return holidays.indexOf(dm + '|') > -1 || holidays.indexOf(dm + '.' + date.getFullYear() + '|') > -1;
  }

  function nextDay(date) {
    var out = new Date(date.getTime());
    out.setDate(out.getDate() + 1);
    return out;
  }

  function startOfToday() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function readable(date, days) {
    return days[date.getDay()].trim() + ' ' + pad(date.getDate()) + '.' + pad(date.getMonth() + 1) + '.';
  }

  /* ---- delivery estimate ------------------------------------------------ */
  function refreshDelivery(el) {
    var days = (el.dataset.days || '').split(',');
    if (days.length < 7) return;

    var saturday = el.dataset.saturday === '1';
    var holidays = el.dataset.holidays || '|';
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    if (isNaN(cutoff) || isNaN(min) || isNaN(max)) return;
    if (max < min) max = min;

    var now = new Date();
    var ship = startOfToday();
    var shipsToday = true;

    if (now.getHours() >= cutoff) {
      shipsToday = false;
      ship = nextDay(ship);
    }
    for (var i = 0; i < 16 && isOff(ship, saturday, holidays); i++) {
      shipsToday = false;
      ship = nextDay(ship);
    }

    var walk = new Date(ship.getTime());
    var counted = 0;
    var first = ship;
    var last = ship;

    for (var j = 0; j < 40 && counted < max; j++) {
      walk = nextDay(walk);
      if (isOff(walk, saturday, holidays)) continue;
      counted++;
      if (counted === min) first = new Date(walk.getTime());
      last = new Date(walk.getTime());
    }

    var template = shipsToday ? el.dataset.textToday : el.dataset.textLater;
    if (!template) return;

    /* one delivery day drops the second half of the phrase, same as in Liquid */
    if (first.getTime() === last.getTime()) {
      template = template.replace(' ili [datum_2]', '').replace('[datum_2]', readable(first, days));
    }

    var sentence = el.querySelector('[data-kraba-delivery-sentence]');
    if (!sentence) return;

    sentence.textContent = template
      .replace('[sat]', cutoff + ':00')
      .replace('[datum_slanja]', readable(ship, days))
      .replace('[datum_1]', readable(first, days))
      .replace('[datum_2]', readable(last, days));
  }

  /* ---- cut the description after a couple of real paragraphs ------------ */
  /* Descriptions come from years of pasting into the rich text editor: some
     use <p>, some a chain of <div>, some are broken up by empty lines and
     images. Counting every child would cut after a heading and one short
     line, so only blocks carrying real text count, and there is a floor the
     preview never drops below. */
  var PARAGRAPH_CHARS = 80;

  function foldHeight(body, wanted, floor) {
    var top = body.getBoundingClientRect().top;
    var kids = body.children;
    var counted = 0;

    for (var i = 0; i < kids.length; i++) {
      if ((kids[i].textContent || '').trim().length < PARAGRAPH_CHARS) continue;

      counted++;
      if (counted >= wanted) {
        return Math.round(kids[i].getBoundingClientRect().bottom - top);
      }
    }

    /* fewer real paragraphs than asked for: everything there is */
    if (!kids.length) return floor;
    return Math.round(kids[kids.length - 1].getBoundingClientRect().bottom - top);
  }

  function measureDescription(el) {
    var body = el.querySelector('[data-kraba-desc-body]');
    if (!body) return;

    /* inside a closed row everything measures zero; leave it for later */
    if (!body.getClientRects().length) return;

    el.classList.remove('is-short');

    var wanted = parseInt(el.dataset.blocks, 10);
    var floor = parseInt(el.dataset.floor, 10) || 200;

    if (wanted > 0 && body.children.length) {
      var cut = Math.max(foldHeight(body, wanted, floor), floor);
      el.style.setProperty('--desc-height', cut + 'px');
      el.style.setProperty('--desc-height-desktop', cut + 'px');
    }

    /* a control for the last line or two is worse than no control */
    if (body.scrollHeight <= body.clientHeight + 60) el.classList.add('is-short');
  }

  /* ---- open or closed right now ----------------------------------------- */
  /* Only used when the phone block is on the page; it is off by default. */
  function refreshSupport(el) {
    var open = parseInt(el.dataset.open, 10);
    var close = parseInt(el.dataset.close, 10);
    if (isNaN(open) || isNaN(close)) return;

    var now = new Date();
    var working = !isOff(startOfToday(), el.dataset.saturday === '1', el.dataset.holidays || '|');
    var isOpen = working && now.getHours() >= open && now.getHours() < close;

    el.classList.toggle('is-open', isOpen);

    var label = el.querySelector('[data-kraba-support-label]');
    if (label) label.textContent = (isOpen ? el.dataset.labelOpen : el.dataset.labelClosed) || '';
  }

  /* ---- keep the bundle in step with the variant picker ------------------ */
  /* The bundle form carries the variant the page was rendered with. When the
     buyer picks another one the main form's hidden input changes, so the
     bundle copies it. Without this the form still works, it would just order
     the variant that was showing on arrival. */
  /* ---- bundle prices follow the pickers -------------------------------- */
  /* Every combination was priced in Liquid and handed over in data-totals, so
     the amounts here always carry the shop's money format instead of one
     guessed at in JavaScript. */
  /* What the buyer has chosen of this product: how many pieces and which
     variant each piece is. The offer cards answer both when they are on the
     page; otherwise it is one piece of whatever the picker says. */
  function chosenBasket() {
    var picked = document.querySelector('[data-kraba-tier]:checked');
    var main = document.querySelector('.product-variant-id');
    var one = main ? main.value : '';
    var count = 1;
    var ids = [];
    var i;

    if (picked) {
      count = parseInt(picked.value, 10) || 1;
      var cell = picked.closest('.kraba-tiers__cell');
      var slots = cell ? cell.querySelectorAll('[data-kraba-tier-slot]') : [];
      if (slots.length === count) {
        for (i = 0; i < slots.length; i++) ids.push(slots[i].value);
      }
    } else {
      var field = document.querySelector('input[name="quantity"]');
      if (field) count = parseInt(field.value, 10) || 1;
    }

    if (!ids.length) {
      for (i = 0; i < count; i++) ids.push(one);
    }
    return { count: count, ids: ids, key: count + ':' + ids.join('-') };
  }

  function syncBundlePrices() {
    var form = document.querySelector('[data-kraba-bundle]');
    if (!form) return;

    var totals;
    try {
      totals = JSON.parse(form.dataset.totals || '{}');
    } catch (e) {
      return;
    }

    /* the pickers sit outside the form and reach it through the form
       attribute, so they are looked up in the document, not in the form */
    var anchor = document.querySelector('[data-kraba-bundle-variant]');
    var select = document.querySelector('[data-kraba-bundle-extra]');
    var fixed = form.querySelector('input[name="items[1][id]"]');
    var extraId = select ? select.value : fixed && fixed.value;
    if (!anchor || !extraId) return;

    /* the offer above owns the question "how many", so the bundle asks it
       rather than assuming one */
    var basket = chosenBasket();
    var count = basket.count;
    var qtyField = form.querySelector('[data-kraba-bundle-qty]');
    if (qtyField) qtyField.value = count;

    var label = document.querySelector('[data-kraba-bundle-count]');
    if (label) {
      label.textContent = count > 1 ? count + ' \u00d7' : '';
      label.hidden = count < 2;
    }

    var total = document.querySelector('[data-kraba-bundle-total]');
    var sum = totals[basket.key + '|' + extraId];
    if (!sum) sum = totals['1:' + anchor.value + '|' + extraId];
    if (total && sum) total.textContent = sum;

    if (select) {
      var price = document.querySelector('[data-kraba-bundle-extra-price]');
      var option = select.options[select.selectedIndex];
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
    }

    var anchorPrice = document.querySelector('[data-kraba-bundle-anchor-price]');
    if (anchorPrice) {
      var line = totals['a' + basket.key];
      if (line) {
        anchorPrice.textContent = line;
      } else {
        var anchorSelect = document.querySelector('[data-kraba-bundle-anchor]');
        var chosen = anchorSelect && anchorSelect.options[anchorSelect.selectedIndex];
        if (chosen && chosen.dataset.price) anchorPrice.textContent = chosen.dataset.price;
      }
    }
  }

  /* The plain form post works on its own; this only takes over to keep the
     buyer on the page when the cart refuses the order, which happens when
     something sells out between the page loading and the button being
     pressed. Shopify's own error page is a dead end, this is not. */
  function watchBundleSubmit() {
    var form = document.querySelector('[data-kraba-bundle]');
    if (!form || form.dataset.krabaWatched) return;
    form.dataset.krabaWatched = 'true';

    form.addEventListener('submit', function (event) {
      var message = form.querySelector('[data-kraba-bundle-error]');

      /* a sold out choice can only be reached by tampering, but it must not
         be allowed to reach the cart either way */
      var pickers = document.querySelectorAll('[data-kraba-bundle-extra], [data-kraba-bundle-anchor]');
      for (var p = 0; p < pickers.length; p++) {
        var picker = pickers[p];
        var chosen = picker.options[picker.selectedIndex];
        if (chosen && chosen.disabled) {
          event.preventDefault();
          for (var i = 0; i < picker.options.length; i++) {
            if (!picker.options[i].disabled) {
              picker.selectedIndex = i;
              break;
            }
          }
          syncBundlePrices();
          return;
        }
      }

      event.preventDefault();
      if (message) message.hidden = true;

      /* a mix of variants is one line per piece, which the plain form cannot
         express, so the payload is rebuilt here */
      var basket = chosenBasket();
      var payload = new FormData(form);
      var mixed = false;
      for (var m = 1; m < basket.ids.length; m++) {
        if (basket.ids[m] !== basket.ids[0]) mixed = true;
      }
      if (mixed) {
        var extraId = payload.get('items[1][id]');
        var extraQty = payload.get('items[1][quantity]') || 1;
        payload = new FormData();
        basket.ids.forEach(function (id, index) {
          payload.append('items[' + index + '][id]', id);
          payload.append('items[' + index + '][quantity]', 1);
        });
        payload.append('items[' + basket.ids.length + '][id]', extraId);
        payload.append('items[' + basket.ids.length + '][quantity]', extraQty);
        payload.append('return_to', orderDestination());
      }

      fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('odbijeno');
          return response.json().catch(function () { return null; });
        })
        .then(function (json) {
          refreshCartSections(json);
          if (orderDestination() === '/checkout') {
            window.location.href = '/checkout';
          } else if (!openEasySellForm()) {
            window.location.href = '/cart#poruci';
          }
        })
        .catch(function () {
          if (message) message.hidden = false;
          else form.submit();
        });
    });
  }

  function watchBundleExtra() {
    var select = document.querySelector('[data-kraba-bundle-extra]');
    if (!select || select.dataset.krabaWatched) return;
    select.dataset.krabaWatched = 'true';
    select.addEventListener('change', syncBundlePrices);
  }

  /* The page's own picker is the single source of truth. The one in the
     bundle is a second way to reach it, never a second answer: choosing in
     the bundle ticks the matching options up the page, which is what makes
     the theme update the price, the gallery and the URL. */
  function driveMainPicker(variantId) {
    var holder = document.querySelector('variant-selects script[type="application/json"]');
    if (!holder) return;

    var variants;
    try {
      variants = JSON.parse(holder.textContent);
    } catch (e) {
      return;
    }

    var wanted = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) wanted = variants[i];
    }
    if (!wanted) return;

    var names = [];
    document.querySelectorAll('variant-selects .product-form__input').forEach(function (group) {
      var radio = group.querySelector('input[type="radio"]');
      if (radio) names.push(radio.name);
    });

    [wanted.option1, wanted.option2, wanted.option3].forEach(function (value, index) {
      if (!value || !names[index]) return;
      var inputs = document.querySelectorAll('input[type="radio"][name="' + names[index].replace(/"/g, '\\"') + '"]');
      for (var j = 0; j < inputs.length; j++) {
        if (inputs[j].value === value && !inputs[j].checked) {
          inputs[j].checked = true;
          inputs[j].dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  function watchBundleAnchor() {
    var select = document.querySelector('[data-kraba-bundle-anchor]');
    if (!select || select.dataset.krabaWatched) return;
    select.dataset.krabaWatched = 'true';

    select.addEventListener('change', function () {
      driveMainPicker(select.value);
      syncBundlePrices();
    });
  }

  /* the page's picker coming back down to the bundle */
  function syncBundleVariant() {
    var target = document.querySelector('[data-kraba-bundle-variant]');
    var source = document.querySelector('.product-variant-id');
    if (!target || !source || !source.value) return;
    if (target.value !== source.value) target.value = source.value;
    syncBundlePrices();
  }

  function watchVariantChanges() {
    var source = document.querySelector('.product-variant-id');
    if (!source || source.dataset.krabaWatched) return;

    source.dataset.krabaWatched = 'true';
    new MutationObserver(syncBundleVariant).observe(source, {
      attributes: true,
      attributeFilter: ['value'],
    });
  }

  /* ---- keep the buy button saying what the merchant wrote --------------- */
  /* The theme sets window.variantStrings after the page content, then reads it
     on every variant change to rewrite the label. This script is deferred, so
     it runs after that assignment and gets the last word. */
  function applyButtonLabel() {
    var button = document.querySelector('[data-kraba-label]');
    if (!button) return;

    var label = button.getAttribute('data-kraba-label');
    if (!label) return;

    window.variantStrings = window.variantStrings || {};
    window.variantStrings.addToCart = label;
  }

  function remeasureDescriptions() {
    document.querySelectorAll('[data-kraba-desc]').forEach(measureDescription);
  }

  /* ---- Recenzije ---------------------------------------------------------
     Every review is already in the HTML. This only adds the controls, which
     is why the server renders them hidden: without script there is nothing
     to filter with, so there is no dead control on the page either. */
  function initReviews(root) {
    if (!root || root.dataset.krabaWatched) return;
    root.dataset.krabaWatched = 'true';

    var list = root.querySelector('[data-kraba-rev-list]');
    if (!list) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-rev-card]'));
    var controls = root.querySelector('[data-kraba-rev-controls]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-rev-filter]'));
    var sorter = root.querySelector('[data-kraba-rev-sort]');
    var more = root.querySelector('[data-kraba-rev-more]');
    var empty = root.querySelector('[data-kraba-rev-empty]');
    var initial = parseInt(root.dataset.initial, 10) || 4;
    var filter = 'sve';
    var shown = initial;

    function num(el, key) {
      return parseInt(el.getAttribute('data-' + key), 10) || 0;
    }

    function matches(card) {
      if (filter === 'sve') return true;
      if (filter === 'slike') return num(card, 'slike') > 0;
      return card.getAttribute('data-ocena') === filter;
    }

    function paint() {
      var seen = 0;
      cards.forEach(function (card) {
        if (!matches(card)) {
          card.hidden = true;
          return;
        }
        seen += 1;
        card.hidden = seen > shown;
      });
      if (empty) empty.hidden = seen > 0;
      if (more) more.hidden = seen <= shown;
    }

    function sortBy(mode) {
      cards = cards.slice().sort(function (a, b) {
        if (mode === 'ocena') {
          return num(b, 'ocena') - num(a, 'ocena') || num(b, 'datum') - num(a, 'datum');
        }
        if (mode === 'korisno') {
          return num(b, 'korisno') - num(a, 'korisno') || num(b, 'datum') - num(a, 'datum');
        }
        return num(b, 'datum') - num(a, 'datum');
      });
      cards.forEach(function (card) {
        list.appendChild(card);
      });
    }

    if (controls) controls.hidden = false;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.getAttribute('data-kraba-rev-filter');
        shown = initial;
        chips.forEach(function (other) {
          other.classList.toggle('is-on', other === chip);
        });
        paint();
      });
    });

    if (sorter) {
      sorter.addEventListener('change', function () {
        sortBy(sorter.value);
        shown = initial;
        paint();
      });
    }

    if (more) {
      more.addEventListener('click', function () {
        shown += initial;
        paint();
      });
    }

    /* the select opens on "najnovije", so the list has to start that way */
    sortBy(sorter ? sorter.value : 'novo');
    paint();

    initLightbox(root);
  }

  /* ---- Lightbox ----------------------------------------------------------
     Shared by the reviews and by the in-use gallery, because both are the
     same job: a run of pictures, opened at the one that was clicked. The
     markup names are neutral so neither section owns it. */
  function initLightbox(root) {
    var box = root.querySelector('[data-kraba-lightbox]');
    var image = root.querySelector('[data-kraba-lb-image]');
    var photos = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-photo]'));
    if (!box || !image || !photos.length) return;

    var at = 0;
    var prev = root.querySelector('[data-kraba-lb-prev]');
    var next = root.querySelector('[data-kraba-lb-next]');
    var closer = root.querySelector('[data-kraba-lb-close]');
    var opener = null;

    if (photos.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    function show(index) {
      at = (index + photos.length) % photos.length;
      image.src = photos[at].getAttribute('data-kraba-photo');
    }

    function open(index, from) {
      opener = from || null;
      show(index);
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (closer) closer.focus();
    }

    function close() {
      box.hidden = true;
      image.src = '';
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    }

    photos.forEach(function (button, index) {
      button.addEventListener('click', function () {
        open(index, button);
      });
    });

    /* a thumbnail in the strip is the same picture as one further down, so it
       opens that one rather than adding a duplicate to the run */
    root.querySelectorAll('[data-kraba-photo-jump]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-kraba-photo-jump');
        var found = 0;
        for (var i = 0; i < photos.length; i++) {
          if (photos[i].getAttribute('data-kraba-photo') === url) {
            found = i;
            break;
          }
        }
        open(found, button);
      });
    });

    if (prev) prev.addEventListener('click', function () { show(at - 1); });
    if (next) next.addEventListener('click', function () { show(at + 1); });
    if (closer) closer.addEventListener('click', close);

    box.addEventListener('click', function (event) {
      if (event.target === box) close();
    });

    document.addEventListener('keydown', function (event) {
      if (box.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(at - 1);
      if (event.key === 'ArrowRight') show(at + 1);
    });
  }

  function initGallery(root) {
    if (!root || root.dataset.krabaWatched) return;
    root.dataset.krabaWatched = 'true';
    initLightbox(root);
  }

  /* The shop's own header pins itself to the top once the page scrolls, so
     anything else that sticks has to park below it. Measured rather than
     guessed, because the bar changes height with the viewport. */
  function publishHeaderHeight() {
    var bar = document.querySelector('.kraba-header__main');
    if (!bar) return;
    document.documentElement.style.setProperty('--kraba-header-h', bar.offsetHeight + 'px');
  }

  /* ---- Video snimci -------------------------------------------------------
     Plays what is on screen and nothing else. On a wide screen that is all
     three at once; on a phone it is the one the buyer has swiped to. The
     source is only attached when a clip is about to play, so a page nobody
     scrolls costs nothing in video. */
  function initVideos(root) {
    if (!root || root.dataset.krabaWatched) return;
    root.dataset.krabaWatched = 'true';

    var clips = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-vid]'));
    if (!clips.length) return;

    var track = root.querySelector('[data-kraba-vid-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-vid-dot]'));
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var quality = wantsLightVideo() ? 'sd' : 'hd';

    function attach(video) {
      if (video.dataset.krabaReady) return;
      video.dataset.krabaReady = 'true';
      var want = quality === 'hd' ? video.getAttribute('data-hd') : null;
      var src = want || video.getAttribute('data-sd');
      if (src) {
        /* replacing the source element keeps the no script fallback honest
           until the moment the script actually takes over */
        while (video.firstChild) video.removeChild(video.firstChild);
        video.src = src;
        video.load();
      }
    }

    function play(video) {
      attach(video);
      if (calm) return;
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    }

    if ('IntersectionObserver' in window) {
      var watcher = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play(entry.target);
            } else if (!entry.target.paused) {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      clips.forEach(function (video) {
        watcher.observe(video);
      });
    } else {
      clips.forEach(play);
    }

    /* ---- dots ---- */
    if (track && dots.length) {
      var marking = false;

      function mark(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-on', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          var item = track.children[index];
          if (!item) return;
          marking = true;
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: calm ? 'auto' : 'smooth' });
          mark(index);
          setTimeout(function () {
            marking = false;
          }, 500);
        });
      });

      var ticking;
      track.addEventListener(
        'scroll',
        function () {
          if (marking) return;
          clearTimeout(ticking);
          ticking = setTimeout(function () {
            var middle = track.scrollLeft + track.clientWidth / 2;
            var nearest = 0;
            var best = Infinity;
            for (var i = 0; i < track.children.length; i++) {
              var item = track.children[i];
              var centre = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
              var gap = Math.abs(centre - middle);
              if (gap < best) {
                best = gap;
                nearest = i;
              }
            }
            mark(nearest);
          }, 90);
        },
        { passive: true }
      );
    }

    /* ---- sound, only when the shop asked for it ---- */
    root.querySelectorAll('[data-kraba-vid-sound]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-kraba-vid-item]');
        var video = item && item.querySelector('[data-kraba-vid]');
        if (!video) return;
        var soundOn = video.muted;
        /* only one clip may be heard at a time */
        if (soundOn) {
          clips.forEach(function (other) {
            other.muted = true;
          });
          root.querySelectorAll('[data-kraba-vid-sound]').forEach(function (other) {
            other.setAttribute('aria-pressed', 'false');
          });
        }
        video.muted = !soundOn;
        button.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
      });
    });
  }

  /* ---- Ponude po količini -------------------------------------------------
     The cards are the visible control; the theme's own quantity input is
     still the field that reaches the cart. Choosing a card writes into that
     input and hides the stepper, so there is one answer to "how many" and it
     is never in two places at once. */
  /*
    The gallery's own video, made lighter before it is ever fetched.

    The theme plays whatever single mp4 the storefront hands it, and what it
    hands over is decided by Shopify, not by us: for one product that is a
    1.5Mbps 480p file, for the next a 7.2Mbps 1080p one. Now that these clips
    start by themselves, that difference is the difference between a phone
    spending three megabytes and spending twenty six on the same swipe.

    The lighter copies exist. Their addresses are not in Liquid, but they are
    listed in the video's own playlist, which is a few hundred bytes and can
    be read from the page. So: read the playlist, work out the 720p address,
    or 480p when the phone asks for less, and write it into data-src before
    the theme loads it. The theme keeps doing exactly what it did.

    If anything at all goes wrong, the playlist, the naming, the file itself,
    the original address is what plays. The error listener below covers the
    last case, where a wrong guess would otherwise leave a dead frame.
  */
  function initGalleryVideo(host) {
    if (host.dataset.krabaLight) return;
    host.dataset.krabaLight = '1';

    var source = host.querySelector('source[data-src]');
    if (!source || source.hasAttribute('src')) return;

    var original = source.getAttribute('data-src');
    if (!original) return;

    var id = (original.match(/\/videos\/c\/vp\/([0-9a-f]{32})\//) || [])[1];
    if (!id) return;

    var want = wantsLightVideo() ? 'SD-480p' : 'HD-720p';

    /*
      Only ever downwards. Where Shopify already handed over the lighter file,
      or one lighter than what is wanted here, it stays: this is here to stop
      a phone pulling a 1080p file, not to talk anyone into a bigger one.
    */
    var weight = function (url) {
      if (url.indexOf('SD-480p') > -1) return 1;
      if (url.indexOf('HD-720p') > -1) return 2;
      return 3;
    };
    if (weight(want) >= weight(original)) return;
    var base = 'https://cdn.shopify.com/videos/c/vp/' + id + '/' + id;

    fetch(base + '.m3u8')
      .then(function (answer) {
        if (!answer.ok) throw new Error('nema liste');
        return answer.text();
      })
      .then(function (list) {
        var line = list.split('\n').map(function (row) { return row.trim(); }).filter(function (row) {
          return row.indexOf(want + '.') > -1 && /\.m3u8$/.test(row);
        })[0];
        if (!line) return;

        var parts = line.match(/^[0-9a-f]{32}\.([A-Z]{2}-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/);
        if (!parts) return;
        if (source.hasAttribute('src')) return;

        source.setAttribute('data-src', base + '.' + parts[1] + '-' + parts[2] + '-' + parts[3] + '.mp4');

        var video = host.querySelector('video');
        if (!video) return;
        video.addEventListener('error', function fallback() {
          video.removeEventListener('error', fallback, true);
          source.setAttribute('src', original);
          video.load();
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        }, true);
      })
      .catch(function () {});
  }

  /*
    Which copy of a clip a visitor gets.

    A phone always gets 480p. The box a clip plays in on a phone is a few
    hundred pixels wide, and the difference between 480p and 720p there is
    a little softness against several megabytes, on a connection the buyer
    often pays for by the megabyte. On a wider screen the picture is large
    enough for the difference to show, so 720p goes there, unless the browser
    says the connection is poor or the visitor asked for less data.
  */
  function wantsLightVideo() {
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return true;

    var net = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!net) return false;
    if (net.saveData) return true;
    return /^(slow-2g|2g|3g)$/.test(net.effectiveType || '');
  }

  /*
    Articles here were written with their own title repeated as the first
    heading of the body, so the page opens by saying the same thing twice,
    once as the page's heading and once again three lines below it.

    Only an exact repeat is removed, compared as text with the spacing and
    the case taken out. An article whose first heading genuinely differs keeps
    it. Nothing is edited in the shop; this only stops the page saying it
    twice.
  */
  function dropRepeatedArticleTitle() {
    dropRepeat(document.querySelector('.article-template__title'), document.querySelector('.rte.article-template__content'));

    var pageTitle = document.querySelector('.main-page-title');
    dropRepeat(pageTitle, pageTitle && pageTitle.parentElement.querySelector('.rte'));
  }

  function dropRepeat(title, body) {
    if (!title || !body) return;

    var first = body.querySelector('h1, h2, h3, p > strong:only-child, p > b:only-child');
    if (!first) return;

    var tidy = function (text) {
      return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    };
    if (tidy(first.textContent) !== tidy(title.textContent)) return;

    var drop = first.tagName === 'STRONG' || first.tagName === 'B' ? first.parentElement : first;
    if (drop && body.contains(drop)) drop.remove();
  }

  /* ---- Pretraga -----------------------------------------------------------

    Shopify's own search already copes with Serbian letters: šoferšajbna and
    sofersajbna find the same thing. What it does not know is how people
    actually speak. Nobody types "stajler za kosu", they type "peglica", and
    that word appears nowhere in the shop, so the search answers with a plush
    teddy. It also ranks a fuzzy match on "mašina za mlevenje" above the two
    products actually called "Masažer".

    Three things are done here, in order of how much they matter:

    1. The shop's own dictionary rewrites the query before it is sent. It is
       written in the theme editor, one pair per line, and it is the only part
       a shop can keep improving without anyone touching code.

    2. What comes back is put in order. The reply is HTML, so the product rows
       are scored against the typed words and moved, never removed: a real
       word match in the title comes first, a word that begins with it next,
       and anything Shopify matched some other way keeps its place below.

    3. Nothing found, so the question is made simpler rather than answered
       with an empty page: the longest word alone, then the first word.

    What the buyer typed is never changed under their fingers. The box keeps
    their words; only the question sent to Shopify is rewritten.
  --------------------------------------------------------------------------- */

  var searchMap = null;
  var lastTyped = '';
  var lastRewrite = '';

  function searchDictionary() {
    if (searchMap) return searchMap;
    searchMap = [];

    var holder = document.getElementById('kraba-search-map');
    if (!holder) return searchMap;

    var raw;
    try { raw = JSON.parse(holder.textContent); } catch (error) { return searchMap; }
    if (!raw) return searchMap;

    raw.split('\n').forEach(function (row) {
      var parts = row.split('=');
      if (parts.length < 2) return;
      var from = foldWord(parts[0]);
      var to = parts.slice(1).join('=').trim();
      if (from && to) searchMap.push({ from: from, to: to });
    });
    return searchMap;
  }

  /* č ć š ž đ down to c c s z d, so one spelling is enough in the dictionary */
  function foldWord(text) {
    return (text || '')
      .toLowerCase()
      .replace(/[čć]/g, 'c')
      .replace(/š/g, 's')
      .replace(/ž/g, 'z')
      .replace(/đ/g, 'd')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function rewriteSearch(query) {
    var folded = foldWord(query);
    if (!folded) return query;

    var dictionary = searchDictionary();

    /* the whole phrase first, so "korpa za ves" wins over "korpa" */
    for (var i = 0; i < dictionary.length; i++) {
      if (dictionary[i].from === folded) return dictionary[i].to;
    }

    /* then word by word, so "peglica za kosu" still finds the styler */
    var words = folded.split(' ');
    var changed = false;
    var rebuilt = words.map(function (word) {
      for (var n = 0; n < dictionary.length; n++) {
        if (dictionary[n].from === word) {
          changed = true;
          return dictionary[n].to;
        }
      }
      return word;
    });
    return changed ? rebuilt.join(' ') : query;
  }

  /*
    The request carries the rewritten question. The box keeps what was typed,
    which is why this happens here and not in the input.
  */
  function interceptSearchRequests() {
    if (!window.fetch || window.fetch.krabaWrapped) return;

    var original = window.fetch;
    var wrapped = function (input, init) {
      try {
        var address = typeof input === 'string' ? input : (input && input.url) || '';
        if (address.indexOf('/search/suggest') > -1) {
          var url = new URL(address, window.location.origin);
          var asked = url.searchParams.get('q');
          var better = rewriteSearch(asked);
          if (better && better !== asked) {
            lastTyped = asked;
            lastRewrite = better;
            url.searchParams.set('q', better);
            input = typeof input === 'string' ? url.toString() : new Request(url.toString(), input);
          }
        }
      } catch (error) { /* a rewrite is never worth a broken search */ }
      return original.apply(this, [input, init]);
    };
    wrapped.krabaWrapped = true;
    window.fetch = wrapped;
  }

  /* the form goes the same way, with the typed words kept for the message */
  var formsBound = false;

  function interceptSearchForms() {
    if (formsBound) return;
    formsBound = true;

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/search') === -1) return;

      var field = form.querySelector('input[name="q"]');
      if (!field) return;

      var better = rewriteSearch(field.value);
      if (!better || better === field.value) return;

      var asked = document.createElement('input');
      asked.type = 'hidden';
      asked.name = 'kraba_q';
      asked.value = field.value;
      form.appendChild(asked);
      field.value = better;
    }, true);
  }

  /*
    Ordering what came back. Shopify answers with rows of HTML, so they are
    scored and moved rather than filtered: nothing is hidden, the likely
    answer is simply first.
  */
  function rankSearchResults(list, query) {
    var words = foldWord(query).split(' ').filter(Boolean);
    if (!words.length) return;

    var rows = Array.prototype.slice.call(list.children);
    if (rows.length < 2) return;

    var scored = rows.map(function (row, position) {
      var title = foldWord((row.querySelector('.predictive-search__item-heading') || row).textContent);
      var score = 0;
      words.forEach(function (word) {
        if (title === word) score += 6;
        else if (new RegExp('(^| )' + word + '( |$)').test(title)) score += 4;
        else if (new RegExp('(^| )' + word).test(title)) score += 3;
        else if (title.indexOf(word) > -1) score += 1;
      });
      return { row: row, score: score, position: position };
    });

    var best = scored.slice().sort(function (a, b) {
      return b.score - a.score || a.position - b.position;
    });

    var moved = best.some(function (item, index) { return item.position !== index; });
    if (!moved) return;

    best.forEach(function (item) { list.appendChild(item.row); });
  }

  function watchPredictiveSearch() {
    var host = document.querySelector('kraba-predictive-search, predictive-search');
    if (!host || host.dataset.krabaRanked) return;
    host.dataset.krabaRanked = '1';

    var order = function () {
      var field = host.querySelector('input[name="q"]');
      var list = host.querySelector('#predictive-search-results-products-list');
      if (field && list) rankSearchResults(list, field.value);

      /*
        The theme writes "Search for X" from whatever it asked the server, and
        on the next keystroke it looks for the previous typed word inside that
        line. Since the server was asked a rewritten question, the word is not
        there, and the theme's own code trips over the empty match. So the
        line is put back to what the buyer typed, which is both what they
        should read and what the theme expects to find.
      */
      var line = host.querySelector('[data-predictive-search-search-for-text]');
      if (line && lastRewrite && line.textContent.indexOf(lastRewrite) > -1) {
        line.textContent = line.textContent.split(lastRewrite).join(lastTyped);
      }
    };

    new MutationObserver(order).observe(host, { childList: true, subtree: true });
  }

  /*
    The search page with nothing on it. Rather than leaving the buyer at a
    dead end, the question is made simpler and the answer offered as a line
    above the empty space: the longest word alone is the best single guess,
    since it is usually the noun.
  */
  function rescueEmptySearch() {
    var page = document.querySelector('#Search-In-Template, #main-search-results, [class*="search-template"]');
    if (!page) return;

    /*
      The buyer typed one thing and the shop searched for another, so the page
      says so. Without this line the results look like the shop ignored the
      question.
    */
    var asked = new URLSearchParams(window.location.search).get('kraba_q');
    var used = new URLSearchParams(window.location.search).get('q');
    if (asked && used && asked !== used && !document.querySelector('[data-kraba-search-rescue]')) {
      showRescue(page, asked, used, []);
    }

    var field = document.querySelector('input[name="q"]');
    var typed = (field && field.value) || new URLSearchParams(window.location.search).get('q') || '';
    if (!typed) return;

    if (page.querySelector('.card-wrapper, .grid__item')) return;
    if (document.querySelector('[data-kraba-search-rescue]')) return;

    var words = foldWord(typed).split(' ').filter(Boolean);
    if (words.length < 2) return;

    var longest = words.slice().sort(function (a, b) { return b.length - a.length; })[0];
    if (longest === foldWord(typed)) return;

    fetch('/search/suggest.json?q=' + encodeURIComponent(longest) + '&resources[type]=product&resources[limit]=6')
      .then(function (answer) { return answer.ok ? answer.json() : Promise.reject(); })
      .then(function (data) {
        var found = (data.resources.results.products || []).filter(function (item) {
          return foldWord(item.title).indexOf(longest) > -1;
        });
        /*
          Only products that really carry the word. Shopify will happily
          answer "frizider" with a hair styler, and a wrong answer under
          "did you mean" is worse than an empty page.
        */
        if (!found.length) return;
        showRescue(page, typed, longest, found);
      })
      .catch(function () {});
  }

  function showRescue(page, typed, used, found) {
    var note = (document.documentElement.dataset.krabaSearchNote || '')
      .replace('[uneto]', typed)
      .replace('[trazeno]', used);

    var box = document.createElement('div');
    box.className = 'kraba-search-rescue page-width';
    box.setAttribute('data-kraba-search-rescue', '');

    var line = document.createElement('p');
    line.className = 'kraba-search-rescue__note';
    line.textContent = note || 'Prikazujemo rezultate za „' + used + '".';
    box.appendChild(line);

    if (!found.length) {
      page.insertBefore(box, page.firstChild);
      return;
    }

    var list = document.createElement('ul');
    list.className = 'kraba-search-rescue__list';
    found.forEach(function (item) {
      var row = document.createElement('li');
      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      row.appendChild(link);
      list.appendChild(row);
    });
    box.appendChild(list);

    page.insertBefore(box, page.firstChild);
  }

  function initTiers(root) {
    if (!root || root.dataset.krabaWatched) return;
    root.dataset.krabaWatched = 'true';

    var options = Array.prototype.slice.call(root.querySelectorAll('[data-kraba-tier]'));
    if (options.length < 2) return;

    var field = document.querySelector('input[name="quantity"]');
    if (!field) return;

    /*
      None of this applies when EasySell is set to run the ordering: the cards
      are on their way out and the page must not first hide the size picker and
      then put it back a second later, in front of someone already reading.
      Read from the setting rather than from the app, because the app answers
      too late to decide a layout.
    */
    if (document.documentElement.dataset.krabaEasysell === '1') return;

    /* the stepper only goes once the cards are known to work, so a failure
       here leaves the buyer with a working page rather than no control */
    document.documentElement.classList.add('kraba-tiers-on');

    /* when every card carries its own variant choice, asking the same
       question again above it is one question too many */
    if (root.hasAttribute('data-owns-variants')) {
      document.documentElement.classList.add('kraba-tiers-variants');
    }

    function chosen() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].checked) return options[i];
      }
      return options[0];
    }

    var combos = {};
    try {
      combos = JSON.parse(root.dataset.combos || '{}');
    } catch (e) {
      combos = {};
    }

    /* Which variant each piece is, for the offer that is chosen. With no
       per piece pickers every piece is simply the variant chosen above. */
    function slotIds(cell, count) {
      var picks = cell ? cell.querySelectorAll('[data-kraba-tier-slot]') : [];
      var ids = [];
      var i;
      if (picks.length === count) {
        for (i = 0; i < picks.length; i++) ids.push(picks[i].value);
        return ids;
      }
      var main = document.querySelector('.product-variant-id');
      var one = main ? main.value : '';
      for (i = 0; i < count; i++) ids.push(one);
      return ids;
    }

    /* The whole price list is worked out in Liquid, so the script only ever
       looks one up. Adding money in JavaScript would mean formatting it in
       JavaScript, and then the page would eventually disagree with the cart
       about where the thousands separator goes. */
    function repriceCard(option) {
      var cell = option.closest('.kraba-tiers__cell');
      var count = parseInt(option.value, 10) || 1;
      var ids = slotIds(cell, count);
      var row = combos[count + ':' + ids.join('-')];
      if (!row) return null;

      var parts = row.split('~');
      var total = parts[0];
      var gross = parts[1];
      var saved = parts[2];
      var each = parts[3];

      option.setAttribute('data-total', total);
      if (cell) {
        var elTotal = cell.querySelector('[data-kraba-tier-total]');
        var elWas = cell.querySelector('[data-kraba-tier-was]');
        var elSaved = cell.querySelector('[data-kraba-tier-saved]');
        var elEach = cell.querySelector('[data-kraba-tier-each]');
        if (elTotal) elTotal.textContent = total;
        if (elWas) elWas.textContent = gross;
        if (elSaved) elSaved.textContent = (root.dataset.savedLabel || '[iznos]').replace('[iznos]', saved);
        if (elEach) elEach.textContent = (root.dataset.eachLabel || '[cena]').replace('[cena]', each);
      }
      return ids;
    }

    function apply() {
      var pick = chosen();
      if (!pick) return;

      options.forEach(repriceCard);
      var ids = repriceCard(pick) || [];

      /* a mixed order cannot travel as one line, so the submit below takes
         over; a uniform one is left to the theme's own form */
      var mixed = false;
      for (var k = 1; k < ids.length; k++) {
        if (ids[k] !== ids[0]) mixed = true;
      }
      root.dataset.krabaMixed = mixed ? ids.join(',') : '';

      if (field.value !== pick.value) {
        field.value = pick.value;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* the sticky bar has to say what the buyer just chose, not what one
         costs, or the two disagree at the exact moment of pressing buy */
      var bars = document.querySelectorAll('.sticky-atc__price');
      var total = pick.getAttribute('data-total');
      for (var b = 0; b < bars.length; b++) {
        bars[b].textContent = total;
      }

      /* one decision about how many, respected everywhere on the page */
      syncBundlePrices();
    }

    options.forEach(function (option) {
      option.addEventListener('change', apply);
    });

    root.querySelectorAll('[data-kraba-tier-slot]').forEach(function (slot) {
      slot.addEventListener('change', function () {
        /* the first piece is what the page shows: its variant drives the
           gallery, the headline price and the address bar, through the
           theme's own picker rather than around it */
        var cell = slot.closest('.kraba-tiers__cell');
        var radio = cell && cell.querySelector('[data-kraba-tier]');
        var first = cell && cell.querySelector('[data-kraba-tier-slot]');
        if (radio && radio.checked && first) {
          root.dataset.krabaDriving = '1';
          driveMainPicker(first.value);
          setTimeout(function () {
            root.dataset.krabaDriving = '';
          }, 400);
        }
        apply();
      });
    });

    /* A mix of variants is several lines in the cart, which a single product
       form cannot post, so the submit is taken over only in that case. With
       every piece the same the theme's own form does the job untouched, and
       so does a visitor without script. */
    var buyForm = field.form || document.querySelector('form[action*="/cart/add"]');
    if (buyForm && !buyForm.dataset.krabaTierWatched) {
      buyForm.dataset.krabaTierWatched = 'true';
      buyForm.addEventListener('submit', function (event) {
        var mix = root.dataset.krabaMixed;
        if (!mix) return;
        event.preventDefault();
        var body = new FormData();
        mix.split(',').forEach(function (id, index) {
          body.append('items[' + index + '][id]', id);
          body.append('items[' + index + '][quantity]', 1);
        });
        fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
          .then(function (response) {
            if (!response.ok) throw new Error('odbijeno');
            window.location.href = orderDestination();
          })
          .catch(function () {
            buyForm.submit();
          });
      });
    }

    apply();

    /* The picker above stays the source of truth. Changing it resets every
       piece to the new variant, so the page never shows a mix the buyer did
       not ask for, and the theme's own rewrite of the sticky price is undone
       afterwards. */
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.hasAttribute && target.hasAttribute('data-kraba-tier-slot')) return;
      if (target.closest('variant-selects') || target.classList.contains('product-variant-id')) {
        setTimeout(function () {
          /* a change the cards themselves asked for must not wipe the mix */
          if (root.dataset.krabaDriving) {
            apply();
            return;
          }
          var main = document.querySelector('.product-variant-id');
          if (main) {
            root.querySelectorAll('[data-kraba-tier-slot]').forEach(function (slot) {
              var option = slot.querySelector('option[value="' + main.value + '"]');
              if (option && !option.disabled) slot.value = main.value;
            });
          }
          apply();
        }, 60);
      }
    });
  }

  /*
    The cart page on a phone is longer than the screen: items, then the
    reassurances, then the summary, then what else you might need. Once the
    real checkout button scrolls away there is nothing left to press, so a copy
    of it rides the bottom edge until the real one is back in view. Same form,
    same name, so it submits the same cart; the number is copied from the
    subtotal rather than remembered, because the theme re-renders that on every
    quantity change.
  */
  var stickyWatcher = null;

  function initCartSticky() {
    var host = document.getElementById('main-cart-footer');
    if (!host) return;

    var bind = function () {
      var bar = host.querySelector('[data-kraba-cart-sticky]');
      var anchor = host.querySelector('.cart__ctas');
      if (!bar || !anchor) return;

      syncStickyTotal(host, bar);
      if (bar.dataset.krabaBound) return;
      bar.dataset.krabaBound = '1';

      if (stickyWatcher) stickyWatcher.disconnect();
      if (!('IntersectionObserver' in window)) {
        bar.classList.add('is-on');
        return;
      }
      stickyWatcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-on', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      stickyWatcher.observe(anchor);
    };

    bind();

    /* the theme swaps .js-contents on every quantity change */
    new MutationObserver(function () {
      bind();
    }).observe(host, { childList: true, subtree: true });
  }

  function syncStickyTotal(host, bar) {
    var from = host.querySelector('.totals__subtotal-value');
    var to = bar.querySelector('[data-kraba-cart-sticky-total]');
    if (from && to && to.textContent.trim() !== from.textContent.trim()) {
      to.textContent = from.textContent.trim();
    }
  }

  /*
    Where a finished basket lands. Normally the checkout. When EasySell runs
    the ordering, the cart page is the last page the theme owns and the one
    that carries EasySell's own form, so the buyer goes there instead and pays
    the price the offer promised.
  */
  function orderDestination() {
    var wanted = document.documentElement.dataset.krabaEasysell === '1';
    var live = window.EASYSELL_CONFIG && window.EASYSELL_CONFIG.active;
    return wanted && live ? '/cart' : '/checkout';
  }

  /*
    EasySell puts its own order form in front of the buyer and charges its own
    quantity prices. Two order buttons then mean two prices for the same three
    pieces, so when it takes over, the theme steps back: its own buy button,
    its quantity picker and its quantity offers are hidden by CSS keyed on the
    class set here.

    The class goes on only after EasySell has actually put a button on the
    page. If the app is off, fails to load, or skips this product, nothing is
    hidden and the theme's own button carries the order as before. That is the
    whole reason this is done in script rather than in Liquid.

    The sticky bar keeps its place and opens EasySell instead: on a phone that
    bar is the only button in reach for most of the page.
  */
  function initEasySell() {
    if (document.documentElement.dataset.krabaEasysell !== '1') return;

    var marked = false;
    var mark = function () {
      var es = document.querySelector('.es-popup-button');
      if (!es || marked) return !!es;
      marked = true;
      document.documentElement.classList.add('kraba-easysell-here');
      retireTierUi();
      bindStickyToEasySell();
      return true;
    };

    /*
      Two different questions. Whether the app is running at all decides the
      drawer, which is on every page. Whether it put a button on this page
      decides what the theme hides here, because a product the app skips must
      keep the theme's own button.
    */
    var announce = function () {
      if (!easySellLive()) return false;
      document.documentElement.classList.add('kraba-easysell');
      revealDrawerButton();
      noteQuantityOffers();
      noteEasySellSticky();
      return true;
    };

    if (!announce()) {
      var tries = 0;
      var poll = setInterval(function () {
        if (announce() || ++tries > 30) clearInterval(poll);
      }, 400);
    }

    /*
      The escape hatch. The theme's own buttons are hidden from the first
      painted frame, before anything is known about the app, so that the old
      button never flashes. If EasySell then never puts a button on a page
      that should have one, the page would be left with no way to order, and
      that is worse than a flash. After seven seconds the theme takes its
      buttons back.
    */
    setTimeout(function () {
      if (document.querySelector('.es-popup-button')) return;

      /*
        Only where EasySell is meant to put a button: the product page and the
        cart page. The drawer is on every page and is never one of those, so
        asking about it here would declare the app missing on the home page,
        where it was never going to appear, and hand the drawer back a button
        to the Shopify checkout.
      */
      var expected = document.querySelector('.product-form__submit.main-product-atc')
        || document.getElementById('main-cart-footer');
      if (!expected) return;

      document.documentElement.classList.add('kraba-easysell-missing');
    }, 7000);

    if (mark()) return;

    /* the app injects late, after its own script has fetched its settings */
    var watcher = new MutationObserver(function () {
      if (mark()) watcher.disconnect();
    });
    watcher.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { watcher.disconnect(); }, 15000);
  }

  function bindStickyToEasySell() {
    var bar = document.querySelector('sticky-atc');
    if (!bar || bar.dataset.krabaEasysellBound) return;
    bar.dataset.krabaEasysellBound = '1';

    bar.addEventListener('click', function (event) {
      var hit = event.target.closest('button, .button');
      if (!hit || hit.closest('.es-popup-button')) return;

      /* the one EasySell button that belongs to the product, not to a bundle */
      var es = document.querySelector('.product-form__buttons .es-popup-button')
        || document.querySelector('.es-popup-button-product')
        || document.querySelector('.es-popup-button');
      if (!es) return;

      event.preventDefault();
      event.stopPropagation();
      es.click();
    }, true);
  }


  /*
    The drawer's button is the one place EasySell does not reach: it only puts
    its button in a drawer opened on the cart page. Everywhere else the drawer
    would quietly offer the Shopify checkout, at the price EasySell's offers do
    not apply to, so in that mode the button hands the buyer to the cart page
    where the form is.
  */
  var drawerBound = false;

  function initDrawerDestination() {
    if (document.documentElement.dataset.krabaEasysell !== '1') return;
    if (drawerBound) return;
    drawerBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('kraba-cart-drawer .cart__checkout-button');
      if (!button) return;
      if (!easySellLive()) return;
      if (button.closest('.cart__ctas') && button.closest('.cart__ctas').querySelector('.es-popup-button')) return;

      event.preventDefault();
      window.location.href = '/cart';
    }, true);

  }

  /*
    On a phone EasySell puts its own bar along the bottom edge. The theme has
    one too, and two bars stacked on top of each other eat a third of a phone
    screen and ask the same thing twice. Theirs is the one that opens the form,
    so the theme's steps aside, and only where theirs has really appeared: if
    the app ever stops putting it there, the theme's bar is back without
    anyone changing a setting. On a desktop EasySell places no bar, so the
    theme keeps its own.

    Their bar is built when the buyer scrolls, not at load, which is why this
    watches for it instead of looking once.
  */
  var stickyWatched = false;

  function noteEasySellSticky() {
    if (document.documentElement.dataset.krabaNoMobileSticky !== '1') return;
    if (!document.querySelector('sticky-atc')) return;

    var mark = function () {
      if (!document.querySelector('.es-sticky')) return false;
      document.documentElement.classList.add('kraba-es-sticky');
      return true;
    };

    if (mark() || stickyWatched) return;
    stickyWatched = true;

    var watcher = new MutationObserver(function () {
      if (mark()) watcher.disconnect();
    });
    watcher.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { watcher.disconnect(); }, 30000);
  }

  /*
    When EasySell carries its own offers for this product, one, two or three
    pieces at its own prices, the number of pieces is decided in that list.
    The theme's plus and minus then asks the same question a second time, in a
    place where the answer does not win, so on those products it steps aside.

    The app builds the list only for products an offer covers, which is why
    its presence in the page is the question asked here rather than anything
    read out of the offer settings. Products without an offer keep the box.
  */
  function noteQuantityOffers() {
    if (document.documentElement.dataset.krabaQtyOffers !== '1') return;
    if (!document.querySelector('.product-form__quantity')) return;

    if (document.querySelector('.es-quantity-offers')) {
      document.documentElement.classList.add('kraba-es-offers');
      return;
    }

    /* the list is built with the rest of the form, a moment after the app wakes */
    if (quantityOffersWatched) return;
    quantityOffersWatched = true;

    var tries = 0;
    var poll = setInterval(function () {
      if (document.querySelector('.es-quantity-offers')) {
        document.documentElement.classList.add('kraba-es-offers');
        clearInterval(poll);
      } else if (++tries > 20) {
        clearInterval(poll);
      }
    }, 500);
  }

  var quantityOffersWatched = false;

  /*
    The drawer's own EasySell button is written by Liquid but kept hidden, and
    shown only once the app is known to be running. The theme rewrites the
    drawer's contents on every quantity change, so this runs again each time
    the drawer changes.
  */
  /*
    A drawer with an empty cart has nothing to show. The theme leaves it open
    on its empty state, and after the contents are swapped for that state it
    can be left as a blank panel over the page. Since the whole drawer exists
    to show what is in the cart, it closes when the cart is emptied, which is
    also what anyone who has just removed their last item expects.
  */
  function closeWhenEmptied() {
    var drawer = document.querySelector('kraba-cart-drawer');
    if (!drawer || drawer.dataset.krabaEmptyWatch) return;
    drawer.dataset.krabaEmptyWatch = '1';

    var shut = function () {
      if (typeof drawer.close === 'function') drawer.close();
    };

    var check = function () {
      if (!drawer.classList.contains('active')) return;
      if (drawer.classList.contains('is-empty')) {
        shut();
        return;
      }

      /*
        And the case nobody planned for: open, but with nothing painted in it.
        Whatever emptied it, a blank panel over the page is never the right
        answer, so it is given a moment to fill and then closed if it has not.
      */
      setTimeout(function () {
        if (!drawer.classList.contains('active')) return;
        var inner = drawer.querySelector('.drawer__inner');
        if (inner && inner.innerText.trim() === '') shut();
      }, 700);
    };

    new MutationObserver(check).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });
    check();
  }

  var drawerWatched = false;

  function revealDrawerButton() {
    var drawer = document.querySelector('kraba-cart-drawer');
    if (!drawer) return;

    /*
      On a product page EasySell puts its own button in this drawer, and it
      opens with the whole cart in it, which is exactly right. On the home page
      and on collections the app is not loaded at all, so there is nothing to
      open and the drawer would be left with the button to the Shopify
      checkout. There this button appears instead, and takes the buyer to the
      cart with the form already opening.
    */
    var show = function () {
      if (!easySellLive()) return;
      var theirs = drawer.querySelector('.es-popup-button');
      drawer.querySelectorAll('[data-kraba-es-drawer]').forEach(function (button) {
        button.hidden = !!theirs;
      });
    };

    show();
    if (drawerWatched) return;
    drawerWatched = true;

    drawer.addEventListener('click', function (event) {
      if (!event.target.closest('[data-kraba-es-drawer]')) return;
      event.preventDefault();

      if (openEasySellForm()) {
        if (typeof drawer.close === 'function') drawer.close();
        return;
      }

      /* the app could not be opened here, so the cart page does it */
      window.location.href = '/cart#poruci';
    });

    new MutationObserver(show).observe(drawer, { childList: true, subtree: true });
  }

  /*
    Every remaining order button on the shop.

    EasySell puts its own button on the product page and on the cart, but it
    never reaches the quick add window that opens from a card on the home page
    or a collection. There the theme's own button was still adding to the cart
    and handing the buyer to the Shopify checkout, at prices EasySell's offers
    never touched. So: the chosen variant goes into the cart, and the same form
    opens over the page.

    The quick add window is closed first, since the form replaces it.

    Card buttons are left alone. "Dodaj u korpu" on a card means put it in the
    cart, and the drawer that follows already carries the order button.
  */
  var buyButtonsBound = false;

  function initBuyButtonTakeover() {
    if (document.documentElement.dataset.krabaEasysell !== '1') return;
    if (buyButtonsBound) return;
    buyButtonsBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.product-form__submit');
      if (!button || button.disabled) return;
      if (!easySellLive()) return;

      var form = button.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (form.querySelector('.es-popup-button')) return;
      if (form.closest('.kraba-bundle')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addThenOrder(form, button);
    }, true);
  }

  function addThenOrder(form, button) {
    var payload = new FormData(form);
    payload.append('sections', 'cart-drawer,cart-icon-bubble');
    payload.append('sections_url', window.location.pathname);

    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: payload,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('odbijeno');
        return response.json();
      })
      .then(function (json) {
        refreshCartSections(json);
        closeQuickAdd(form);
        if (!openEasySellForm()) window.location.href = '/cart#poruci';
      })
      .catch(function () {
        form.submit();
      })
      .then(function () {
        button.classList.remove('loading');
      });
  }

  /*
    The cart count in the header and the drawer's contents are rendered by the
    server, so they are taken from the same reply that added the item. Written
    in rather than handed to the theme's own renderer, because that one opens
    the drawer as it goes and the form is what should be opening here.
  */
  function refreshCartSections(json) {
    if (!json || !json.sections) return;

    var read = function (name) {
      var markup = json.sections[name];
      return markup ? new DOMParser().parseFromString(markup, 'text/html') : null;
    };

    /* the drawer is replaced whole, exactly as the theme replaces it */
    var drawerDoc = read('cart-drawer');
    var freshDrawer = drawerDoc && drawerDoc.querySelector('.drawer__inner');
    var liveDrawer = document.querySelector('kraba-cart-drawer .drawer__inner');
    if (freshDrawer && liveDrawer) liveDrawer.innerHTML = freshDrawer.innerHTML;

    /*
      The count only. That section carries the theme's own cart link, while
      the header here is kraba's, so taking the whole thing would overwrite
      the icon with a different one. The number is the part that changed.
    */
    var bubbleDoc = read('cart-icon-bubble');
    var host = document.getElementById('cart-icon-bubble');
    if (!bubbleDoc || !host) return;

    var fresh = bubbleDoc.querySelector('.cart-count-bubble');
    var live = host.querySelector('.cart-count-bubble');
    if (fresh && live) live.innerHTML = fresh.innerHTML;
    else if (fresh) host.appendChild(fresh);
    else if (live) live.remove();
  }

  function closeQuickAdd(form) {
    var modal = form.closest('quick-add-modal, .quick-add-modal');
    if (!modal) return;
    if (typeof modal.hide === 'function') {
      modal.hide();
      return;
    }
    var toggle = modal.querySelector('.quick-add-modal__toggle, [id^="ModalClose"]');
    if (toggle) toggle.click();
  }

  /*
    Opening EasySell's form where the app did not put a button of its own.

    Its form is built into every page, sitting in #easysell with display none;
    what the app does on a product page is show it, move it into its modal and
    tell its own component that a button was pressed. Those are the same three
    steps here, with true meaning "pressed in a drawer", which is the app's own
    flag for reading the whole cart rather than adding one variant to it.

    This reaches inside someone else's script, so it is written to fail
    quietly: any missing piece returns false and the caller falls back to the
    cart page, where the app puts a real button and nothing is guessed.
  */
  function openEasySellForm() {
    try {
      var host = document.getElementById('easysell');
      var slot = document.querySelector('#easysell-modal .es-modal-content');
      if (!host || !slot) return false;

      var component = findEasySellComponent(window.easysellApp, 0, []);
      if (!component) return false;

      if (host.parentElement !== slot) slot.appendChild(host);
      host.style.display = 'block';
      component.popupListner(true);
      return true;
    } catch (error) {
      return false;
    }
  }

  function findEasySellComponent(vm, depth, seen) {
    if (!vm || depth > 6 || seen.indexOf(vm) > -1) return null;
    seen.push(vm);
    if (typeof vm.popupListner === 'function') return vm;

    var children = vm.$children || [];
    for (var i = 0; i < children.length; i++) {
      var hit = findEasySellComponent(children[i], depth + 1, seen);
      if (hit) return hit;
    }
    return null;
  }

  /*
    Arriving from that button. The buyer already pressed order once, so the
    form opens without a second press, as soon as EasySell has put its button
    on the cart page. The mark is taken out of the address straight away, so a
    reload or a shared link does not open it again.
  */
  function openFormOnArrival() {
    if (window.location.hash !== '#poruci') return;
    if (document.documentElement.dataset.krabaEasysell !== '1') return;

    history.replaceState(null, '', window.location.pathname + window.location.search);

    var tries = 0;
    var poll = setInterval(function () {
      var button = document.querySelector('#main-cart-footer .cart__ctas .es-popup-button');
      if (button) {
        clearInterval(poll);
        button.click();
      } else if (++tries > 40) {
        clearInterval(poll);
      }
    }, 250);
  }

  /*
    The quantity cards did two jobs: they asked how many, and on a product
    whose cards each carry a size they also asked which one, which is why the
    theme's own variant picker was told to stand down. With the cards gone the
    picker is the only place left to choose a size, so it comes back.
  */
  function retireTierUi() {
    document.documentElement.classList.remove('kraba-tiers-variants');
    document.documentElement.classList.remove('kraba-tiers-on');
  }

  /*
    Live means two things, and the settings alone are not enough. They arrive
    with the page, written by the app's embed, and they stay there even when
    the app's script never loads. The form itself is built by that script, so
    its modal in the page is the honest proof that the app can actually open
    anything. Without it the theme keeps its own buttons instead of offering
    one that would open nothing.
  */
  function easySellLive() {
    if (!(window.EASYSELL_CONFIG && window.EASYSELL_CONFIG.active)) return false;
    return !!document.getElementById('easysell-modal');
  }

  /* ------------------------------------------------------------------ */
  /*  Order button guard                                                  */
  /* ------------------------------------------------------------------ */

  /*
    Nothing on this shop may show a price and no way to buy.

    Several rules hide the theme's own order buttons from the first painted
    frame so EasySell's can take their place without a flash. That is right
    while EasySell turns up. It is a lost sale when it does not: an ad blocker
    eats the app's script, the app skips a product, a section re-renders and
    takes the injected button with it, or a window opens with markup the app
    was never going to reach.

    So rather than name every such case, this watches the result. Any add to
    cart form, the cart footer and the cart drawer, whenever one of them is on
    screen with no pressable order button, gets a class that puts the theme's
    own button back over every rule above.

    The grace period is what keeps it from fighting the thing it protects: a
    product page that is about to get EasySell's button is left alone for a
    couple of seconds, long enough for the app to arrive on a slow phone, and
    only rescued if it still has nothing. Once rescued, a form is left rescued
    unless EasySell actually shows up, otherwise the two would take turns
    hiding each other.
  */
  var CTA_GRACE = 2500;
  var firstSeen = new WeakMap();
  var ctaGuardBound = false;

  function onScreen(el) {
    if (!el || el.hidden) return false;
    if (typeof el.getClientRects === 'function' && el.getClientRects().length === 0) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function anyOnScreen(host, selector) {
    var found = false;
    host.querySelectorAll(selector).forEach(function (el) {
      if (!found && onScreen(el)) found = true;
    });
    return found;
  }

  /*
    theirs: EasySell is handling this one, so the theme stays out of the way.
    mine:   something pressable is already there, nothing to do.
    Neither, and the grace period is over: put the theme's button back.
  */
  function judge(host, theirsSelector, mineSelector) {
    if (!onScreen(host)) return;

    if (anyOnScreen(host, theirsSelector)) {
      host.classList.remove('kraba-cta-rescue');
      firstSeen.delete(host);
      return;
    }

    if (host.classList.contains('kraba-cta-rescue')) return;
    if (anyOnScreen(host, mineSelector)) return;

    var seen = firstSeen.get(host);
    if (!seen) {
      firstSeen.set(host, Date.now());
      return;
    }
    if (Date.now() - seen < CTA_GRACE) return;

    host.classList.add('kraba-cta-rescue');
  }

  /*
    EasySell labels its button from a table built into its script, keyed by
    the shop's language. Serbian here runs through the English locale, so a
    sold out variant comes out as "Sold Out" in the middle of a Serbian page.
    Only the wording is touched, and on every pass, because the app rewrites
    the label itself whenever the variant changes.
  */
  function serbianiseEasySell() {
    document.querySelectorAll('.es-popup-button').forEach(function (button) {
      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        if (/^\s*sold\s*out\s*$/i.test(node.nodeValue)) node.nodeValue = 'Rasprodato';
      }
    });
  }

  /*
    EasySell drops its quantity offers into the same box as the order button.
    That box is a row, so without this the offers and the button end up side
    by side: a column of choices, and a tall thin button squeezed in beside
    them. Marked on the box itself rather than read off a class on <html>,
    because that one only appears when a particular setting is on, while this
    has to hold whenever the offers are actually there.
  */
  function markOfferRows() {
    document.querySelectorAll('.product-form__quantity-and-btn').forEach(function (row) {
      var hasOffers = !!row.querySelector('.es-quantity-offers');
      if (row.classList.contains('kraba-row-offers') === hasOffers) return;
      row.classList.toggle('kraba-row-offers', hasOffers);
    });
  }

  function guardCta() {
    serbianiseEasySell();
    markOfferRows();

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      /* the bundle carries its own button and its own rules */
      if (form.closest('.kraba-bundle')) return;

      /*
        Shopify's installment form posts to the same address and has no button
        of its own, ever. Nothing to put back, so nothing to watch.
      */
      if (!form.querySelector('.product-form__submit, [name="add"], button[type="submit"], .es-popup-button')) return;

      judge(form, '.es-popup-button', '.product-form__submit, [name="add"], button[type="submit"]');
    });

    var footer = document.getElementById('main-cart-footer');
    if (footer) {
      judge(
        footer,
        '.es-popup-button, [data-kraba-es-drawer]:not([hidden])',
        '.cart__checkout-button, .kraba-cart-sticky__btn'
      );
    }

    document.querySelectorAll('kraba-cart-drawer').forEach(function (drawer) {
      if (drawer.classList.contains('is-empty')) return;
      var ctas = drawer.querySelector('.cart__ctas');
      if (!ctas) return;
      judge(
        ctas,
        '.es-popup-button, [data-kraba-es-drawer]:not([hidden])',
        '.cart__checkout-button'
      );
    });
  }

  /*
    A last door left open.

    The drawer, the cart page and the product page all have their checkout
    button hidden while EasySell runs the ordering, but the theme has one more
    place with the same button: the cart notification, which is what the shop
    shows instead of the drawer if that setting is ever changed. Its button
    goes straight to the Shopify checkout, at prices EasySell's offers never
    touched.

    Rather than name that one place, every remaining checkout button on the
    shop is turned towards EasySell's form. Only while the app is actually
    able to open it: when it is not, these buttons are the fallback and must
    keep working as they are.
  */
  /*
    A note under the street field of EasySell's form.

    The call centre kept getting orders with only a house number in the street
    field, or a street with no number, and had to phone each one back before it
    could ship. Nothing is refused here: a village address may honestly have no
    number, and the form is not ours to block. The note appears once the field
    is left, says in plain words what is missing, and goes away the moment the
    value is complete.

    It hangs off the field's column rather than the input itself, because the
    input shares a row with its icon and a paragraph in that row would squeeze
    both. Listening on the document keeps it working if the app redraws the
    form.
  */
  var addressHintBound = false;

  function addressHintText(value) {
    var v = (value || '').trim();
    if (!v) return '';
    if (!/[a-zčćžšđа-яђјљњћџ]/i.test(v)) {
      return 'Upišite i naziv ulice, ne samo broj. Na primer: Cara Dušana 12';
    }
    if (!/\d/.test(v) && !/\bb\.?\s?b\.?\b|bez\s+broja/i.test(v)) {
      return 'Dodajte kućni broj. Ako ga nemate, upišite bb, na primer: Gornji Aleksinac bb';
    }
    return '';
  }

  function showAddressHint(field) {
    var column = field.closest('.es-input-column') || field.parentElement;
    if (!column) return;
    var hint = column.querySelector('.kraba-address-hint');
    var text = addressHintText(field.value);

    if (!text) {
      if (hint) hint.remove();
      field.removeAttribute('aria-describedby');
      return;
    }
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'kraba-address-hint';
      hint.id = 'kraba-address-hint';
      hint.setAttribute('role', 'status');
      column.appendChild(hint);
    }
    hint.textContent = text;
    field.setAttribute('aria-describedby', hint.id);
  }

  function initAddressHint() {
    if (addressHintBound) return;
    addressHintBound = true;

    document.addEventListener('focusout', function (event) {
      if (event.target && event.target.id === 'es-address') showAddressHint(event.target);
    }, true);

    /* once shown, it follows the typing so it disappears as soon as it is right */
    document.addEventListener('input', function (event) {
      var field = event.target;
      if (!field || field.id !== 'es-address') return;
      var column = field.closest('.es-input-column') || field.parentElement;
      if (column && column.querySelector('.kraba-address-hint')) showAddressHint(field);
    }, true);
  }

  function initCheckoutGuard() {
    if (document.documentElement.dataset.krabaEasysell !== '1') return;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[name="checkout"], .cart__checkout-button');
      if (!button) return;
      if (button.hasAttribute('data-kraba-es-drawer')) return;
      if (button.closest('.es-popup-button')) return;

      /* the button is only there because EasySell is not; leave it alone */
      if (button.closest('.kraba-cta-rescue')) return;
      if (document.documentElement.classList.contains('kraba-easysell-missing')) return;
      if (!easySellLive()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (!openEasySellForm()) window.location.href = '/cart#poruci';
    }, true);
  }

  function initCtaGuard() {
    if (ctaGuardBound) return;
    ctaGuardBound = true;

    /*
      The observer below watches the whole document, so a slider or a hover
      can ask for this sixty times a second. A fifth of a second is still far
      quicker than a shopper can reach for anything, and costs nothing on a
      cheap phone.
    */
    var queued = false;
    var soon = function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        guardCta();
      }, 200);
    };

    soon();
    window.addEventListener('load', soon);

    /*
      Markup arrives from three directions: the theme re-rendering a section,
      a dialog opening, and EasySell injecting. The observer catches the
      first two; the heartbeat catches anything that changes nothing in the
      DOM, and carries the grace period over the line for a form that was
      already on the page when this started.
    */
    new MutationObserver(soon).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'disabled'],
    });

    var ticks = 0;
    var beat = setInterval(function () {
      guardCta();
      if (++ticks > 60) clearInterval(beat);
    }, 500);

    /* the drawer and the modal open long after that heartbeat has stopped */
    document.addEventListener('click', function () {
      setTimeout(guardCta, 400);
      setTimeout(guardCta, 1200);
      setTimeout(guardCta, 3000);
    }, true);
  }

  function run() {
    applyButtonLabel();
    syncBundleVariant();
    watchVariantChanges();
    watchBundleExtra();
    watchBundleAnchor();
    watchBundleSubmit();
    syncBundlePrices();
    document.querySelectorAll('[data-kraba-delivery]').forEach(refreshDelivery);
    document.querySelectorAll('[data-kraba-support]').forEach(refreshSupport);
    publishHeaderHeight();
    document.querySelectorAll('[data-kraba-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-kraba-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-kraba-videos]').forEach(initVideos);
    document.querySelectorAll('internal-video[data-autoplay="true"]').forEach(initGalleryVideo);
    document.querySelectorAll('[data-kraba-tiers]').forEach(initTiers);
    initCartSticky();
    dropRepeatedArticleTitle();
    interceptSearchRequests();
    interceptSearchForms();
    watchPredictiveSearch();
    rescueEmptySearch();
    initEasySell();
    initBuyButtonTakeover();
    initDrawerDestination();
    closeWhenEmptied();
    openFormOnArrival();
    initCtaGuard();
    initCheckoutGuard();
    initAddressHint();
    remeasureDescriptions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* images in the description land after DOMContentLoaded and change its height */
  window.addEventListener('load', remeasureDescriptions);

  /* opening the row is the first time the text has a height to measure */
  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('accordion__details')) {
      setTimeout(remeasureDescriptions, 260);
    }
  }, true);

  /* a resize changes where the chosen paragraph ends */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      remeasureDescriptions();
      publishHeaderHeight();
    }, 200);
  });

  /* the theme editor re-renders sections without reloading the page */
  document.addEventListener('shopify:section:load', run);
})();
